import { PreviewControllerOfPage } from './preview-controller-page';
import { ElementType, Location } from './element-type';
import { FromTo } from './report-template';

export class PreviewController {
  private readonly pageIds: Array<string>;
  private readonly pageController: { [pageId: string]: PreviewControllerOfPage };

  constructor() {
    this.pageIds = new Array<string>();
    this.pageController = {};
  }

  public getPageIds(): Array<string> {
    return this.pageIds;
  }
  public getIds(pageId: string, location: Location, type: ElementType): Array<string> {
    return this.pageController[pageId].getIds(location, type);
  }

  public previewElementsIds(pageId: string): string[] {
    const previewIds = this.pageController[pageId].previewElementsIds();
    return previewIds;
  }


  public addPage(pageId: string | Array<string>, viewPageId?:string): void;
  public addPage(pageId: any, viewPageId?:string): void {

    const typeOf = Object.prototype.toString;
    const ids = typeOf.call(pageId) === '[object Array]' ? pageId : [pageId];

    ids.forEach((id: string) => {
      if (viewPageId) {
        const startNumber = this.pageIds.indexOf(viewPageId)
        this.pageIds.splice(startNumber + 1, 0, pageId);
      }
      else {
        this.pageIds.push(pageId);
      }     
      this.pageController[pageId] = new PreviewControllerOfPage();
    });
  }

  public removePage(pageId: string | Array<string>): void;
  public removePage(pageId: any): void {

    const typeOf = Object.prototype.toString;
    const pageIds: Array<string> = typeOf.call(pageId) === '[object Array]' ? pageId : [pageId];

    pageIds.forEach((id: string) => {
      const result = this.pageIds.indexOf(id);
      if (result !== -1) {
        this.pageIds.splice(result, 1);
      }
    });

    pageIds.forEach((id: string) => {
      delete this.pageController[id];
    });
  }

  public removeAllPage() {
    const length = this.pageIds.length;
    this.pageIds.splice(0, length);

    Object.keys(this.pageController).forEach((propertyName: string) => {
      delete this.pageController[propertyName];
    });
  }

  public draw(pageId: string, location: Location, type: ElementType, id: string | Array<string>);
  public draw(pageId: string, location: Location, type: ElementType, id: any) {
    this.pageController[pageId].draw(location, type, id);
  }

  public remove(pageId: string, location: Location, id: string | Array<string>);
  public remove(pageId: string, location: Location, id: any) {
    this.pageController[pageId].remove(location, id);
  }

  public removeAll(pageId: string, location: Location, type: ElementType) {
    this.pageController[pageId].removeAll(location, type);
  }

  public move(id: string, type: ElementType, fromTo: FromTo) {
    const from = fromTo.from;
    const to = fromTo.to;
    this.pageController[from.pageId].remove(from.location, id);
    this.pageController[to.pageId].draw(to.location, type, id);
  }

  public redrawHeader(
    pageId: string, hasHeader: boolean,
    newTextIds: Array<string>,
    newLineIds: Array<string>,
    newImageIds: Array<string>,
    newRectangleIds: Array<string>,
    newSummaryIds: Array<string>,
    newPictureIds: Array<string>,
    newDataPlateIds: Array<string>,
    newSignatureIds: Array<string>,
    newTableIds: Array<string>
  ) {
    this.removeAll(pageId, Location.Header, ElementType.Text);
    this.removeAll(pageId, Location.Header, ElementType.Line);
    this.removeAll(pageId, Location.Header, ElementType.Image);
    this.removeAll(pageId, Location.Header, ElementType.Rectangle);
    this.removeAll(pageId, Location.Header, ElementType.Summary);
    this.removeAll(pageId, Location.Header, ElementType.Picture);
    this.removeAll(pageId, Location.Header, ElementType.DataPlate);
    this.removeAll(pageId, Location.Header, ElementType.Signature);
    this.removeAll(pageId, Location.Header, ElementType.Table);
    if (hasHeader) {
      this.draw(pageId, Location.Header, ElementType.Text, newTextIds);
      this.draw(pageId, Location.Header, ElementType.Line, newLineIds);
      this.draw(pageId, Location.Header, ElementType.Image, newImageIds);
      this.draw(pageId, Location.Header, ElementType.Rectangle, newRectangleIds);
      this.draw(pageId, Location.Header, ElementType.Summary, newSummaryIds);
      this.draw(pageId, Location.Header, ElementType.Picture, newPictureIds);
      this.draw(pageId, Location.Header, ElementType.DataPlate, newDataPlateIds);
      this.draw(pageId, Location.Header, ElementType.Signature, newSignatureIds);
      this.draw(pageId, Location.Header, ElementType.Table, newTableIds);
    }
  }

  public redrawFooter(
    pageId: string, hasFooer: boolean,
    newTextIds: Array<string>,
    newLineIds: Array<string>,
    newImageIds: Array<string>,
    newRectangleIds: Array<string>,
    newSummaryIds: Array<string>,
    newPictureIds: Array<string>,
    newDataPlateIds: Array<string>,
    newSignatureIds: Array<string>,
    newTableIds: Array<string>
  ) {
    this.removeAll(pageId, Location.Footer, ElementType.Text);
    this.removeAll(pageId, Location.Footer, ElementType.Line);
    this.removeAll(pageId, Location.Footer, ElementType.Image);
    this.removeAll(pageId, Location.Footer, ElementType.Rectangle);
    this.removeAll(pageId, Location.Footer, ElementType.Summary);
    this.removeAll(pageId, Location.Footer, ElementType.SubTotal);
    this.removeAll(pageId, Location.Footer, ElementType.Picture);
    this.removeAll(pageId, Location.Footer, ElementType.DataPlate);
    this.removeAll(pageId, Location.Footer, ElementType.Signature);
    this.removeAll(pageId, Location.Footer, ElementType.Table);
    if (hasFooer) {
      this.draw(pageId, Location.Footer, ElementType.Text, newTextIds);
      this.draw(pageId, Location.Footer, ElementType.Line, newLineIds);
      this.draw(pageId, Location.Footer, ElementType.Image, newImageIds);
      this.draw(pageId, Location.Footer, ElementType.Rectangle, newRectangleIds);
      this.draw(pageId, Location.Footer, ElementType.Summary, newSummaryIds);
      this.draw(pageId, Location.Footer, ElementType.Picture, newPictureIds);
      this.draw(pageId, Location.Footer, ElementType.Signature, newSignatureIds);
      this.draw(pageId, Location.Footer, ElementType.Table, newTableIds);
    }
  }

  public redrawBody(
    pageId: string,
    newTextIds: Array<string>,
    newLineIds: Array<string>,
    newImageIds: Array<string>,
    newRectangleIds: Array<string>,
    newSummaryIds: Array<string>,
    newSubTotalIds: Array<string>,
    newPictureIds: Array<string>,
    newDataPlateIds: Array<string>,
    newMeasurementPointIds: Array<string>,
    newVisualEventsIds: Array<string>,
    newSignatureIds: Array<string>,
    newSectionIds: Array<string>,
    newTableIds: Array<string>,
    newInteractiveIsoIds: Array<string>,
    newDropDownListIds: Array<string>,
    newCustomElementIds: Array<string>
  ) {
    this.removeAll(pageId, Location.Body, ElementType.Text);
    this.removeAll(pageId, Location.Body, ElementType.Line);
    this.removeAll(pageId, Location.Body, ElementType.Image);
    this.removeAll(pageId, Location.Body, ElementType.Rectangle);
    this.removeAll(pageId, Location.Body, ElementType.Summary);
    this.removeAll(pageId, Location.Body, ElementType.SubTotal);
    this.removeAll(pageId, Location.Body, ElementType.Picture);
    this.removeAll(pageId, Location.Body, ElementType.DataPlate);
    this.removeAll(pageId, Location.Body, ElementType.MeasurementPoint);
    this.removeAll(pageId, Location.Body, ElementType.VisualEvents);
    this.removeAll(pageId, Location.Body, ElementType.Signature);
    this.removeAll(pageId, Location.Body, ElementType.Section);
    this.removeAll(pageId, Location.Body, ElementType.Table);
    this.removeAll(pageId, Location.Body, ElementType.InteractiveIso);
    this.removeAll(pageId, Location.Body, ElementType.DropDownList);
    this.removeAll(pageId, Location.Body, ElementType.CustomElement);
    this.draw(pageId, Location.Body, ElementType.Text, newTextIds);
    this.draw(pageId, Location.Body, ElementType.Line, newLineIds);
    this.draw(pageId, Location.Body, ElementType.Image, newImageIds);
    this.draw(pageId, Location.Body, ElementType.Rectangle, newRectangleIds);
    this.draw(pageId, Location.Body, ElementType.Summary, newSummaryIds);
    this.draw(pageId, Location.Body, ElementType.SubTotal, newSubTotalIds);
    this.draw(pageId, Location.Body, ElementType.Picture, newPictureIds);
    this.draw(pageId, Location.Body, ElementType.DataPlate, newDataPlateIds);
    this.draw(pageId, Location.Body, ElementType.MeasurementPoint, newMeasurementPointIds);
    this.draw(pageId, Location.Body, ElementType.VisualEvents, newVisualEventsIds);
    this.draw(pageId, Location.Body, ElementType.Signature, newSignatureIds);
    this.draw(pageId, Location.Body, ElementType.Section, newSectionIds);
    this.draw(pageId, Location.Body, ElementType.Table, newTableIds);
    this.draw(pageId, Location.Body, ElementType.InteractiveIso, newInteractiveIsoIds);
    this.draw(pageId, Location.Body, ElementType.DropDownList, newDropDownListIds);
    this.draw(pageId, Location.Body, ElementType.CustomElement, newCustomElementIds);
  }
}
